import { InStockNotificationRequest } from './../../types/generated';

export const apiPathProducts = '/umbraco/surface/productssurface/';
export const apiPathUser = '/umbraco/surface/usersurface/';
export const apiPathInStock = '/umbraco/surface/instocknotificationsurface/';
export const apiPathBasket = '/umbraco/surface/basketsurface/';

const fetchBaseConfig: RequestInit = {
  credentials: 'same-origin',
  headers: {
    'content-type': 'application/json',
    accept: 'application/json'
  }
};

export function getProductDataByVariants() {
  console.log('do something');
}

export const getIsFavourite = (catalogueRef?: string | null) => {
  const path = `${apiPathProducts}GetProductIsFavourite/?catalogueRef=${catalogueRef}`;

  return fetch(path, fetchBaseConfig).then((response) => {
    return response.json();
  });
};

export const getIsDownloadUser = () => {
  const path = `${apiPathUser}GetIsDownloadUser`;

  return fetch(path, fetchBaseConfig).then((response) => {
    return response.json();
  });
};

export const registerForInStockNotification = (
  form: Partial<InStockNotificationRequest>
) => {
  const path = `${apiPathInStock}RegisterForInStockNotification`;
  const data = { ...form };
  const config: RequestInit = {
    ...fetchBaseConfig,
    body: JSON.stringify(data),
    method: 'POST'
  };

  return fetch(path, config).then((response) => {
    return response.json();
  });
};

export const getProductByProductId = (productId: number) => {
  const path = `${apiPathProducts}GetProductByProductId/?productId=${productId}`;

  return fetch(path, fetchBaseConfig).then((response) => {
    return response.json();
  });
};

export const getProductQuantityInBasket = (catalogueRef: string) => {
  const path = `${apiPathBasket}GetProductQuantityInBasket/?catalogueRef=${catalogueRef}`;

  return fetch(path, fetchBaseConfig).then((response) => {
    return response.json();
  });
};
